/**
 * Fixed reference dimensions for the seating canvas, in CSS px.
 *
 * The room frame — and every table inside it, positioned by percentage — is
 * sized relative to THIS constant, never the live viewport.  Exported here so
 * both the canvas component and the Firestore operations helpers can import it
 * without creating a circular dependency through the React component tree.
 */
export const REFERENCE_CANVAS = { w: 1200, h: 860 } as const;

/** Desktop unassigned-guest sidebar width (px). */
export const UNASSIGNED_PANEL_WIDTH = 220;

/** Head table for the wedding couple (para młoda) — intimate, max 4 seats. */
export const VIP_TABLE_CAPACITY = 4;
